<template>
	<div style="min-height: 300px; height: 300px">
		<b-row>
			<b-col cols="6" xs="6" sm="6" md="5" lg="5" xl="5">
				<div class="sa-pianificazione-edit-container">
					<vc-calendar :attributes="attributes" transition="fade" nav-visibility="hidden" @dayclick="onDayClick" />
				</div>
			</b-col>
			<b-col cols="6" xs="6" sm="6" md="7" lg="7" xl="7">
				<div class="sa-pianificazione-edit-container">
					<div style="display: flex; flex-direction: row">
						<div style="flex: 1">
							<b-row>
								<b-col cols="6" xs="12" sm="12" md="12" lg="12" xl="12">
									<b-row>
										<b-col cols="6" xs="6" sm="6" md="6" lg="6" xl="6">
											<b-input-group class="mb-3">
												<label style="width: 100%" for="">Date del Mese:</label>
												<br />
												<b-form-input v-model="giorniSelezionati" readonly></b-form-input>
											</b-input-group>
										</b-col>
										<b-col cols="6" xs="6" sm="6" md="6" lg="6" xl="6">
											<b-row>
												<b-col cols="6" xs="6" sm="6" md="6" lg="6" xl="6">
													<b-input-group class="mb-3">
														<label style="width: 100%" for="">Frequenza:</label>
														<br />
														<b-form-select v-model="frequenzaDayWeek" :options="frequenzaDaysWeekOptions" value-field="code" text-field="text" @input="onInputFrequenzaDayWeek"></b-form-select>
													</b-input-group>
												</b-col>
												<b-col cols="6" xs="6" sm="6" md="6" lg="6" xl="6">
													<b-input-group class="mb-3">
														<label style="width: 100%" for="">Giorni del Mese:</label>
														<br />
														<b-form-select v-model="dayWeek" :options="daysWeekOptions" value-field="code" text-field="day" @input="onInputDayWeek"></b-form-select>
													</b-input-group>
												</b-col>
											</b-row>
										</b-col>
										<b-col cols="6" xs="12" sm="12" md="12" lg="12" xl="12">
											<b-input-group class="mb-3">
												<label for="">Orario di Riferimento</label>
												<date-picker format="HH:mm" value-type="timestamp" v-model="orarioRiferimento" :disabled-time="disbilitaOrePrecedenti" placeholder="HH:mm" :default-value="new Date()" :minute-step="15" type="time"></date-picker>
											</b-input-group>
										</b-col>
									</b-row>
								</b-col>
								<b-col cols="6" xs="6" sm="12" md="12" lg="12" xl="12">
									<div class="sa-pianificazione-edit-container" style="height: 280px; overflow: auto; padding-bottom: 109px">
										<label class="sa-label-data">Elenco delle prossime {{ numeroElencoProgrammatoLbl }} attività programmate:</label>
										<div v-for="(attivita, index) in elencoAttivitaProgrammate" :key="index" style="display: flex; flex-direction: row" :class="getClass(index)">
											<div style="flex: 1; display: table">
												<span style="display: table-cell; vertical-align: middle; font-size: var(--label-font-size)"> {{ index + 1 }} - {{ attivita }} </span>
											</div>
										</div>
									</div>
								</b-col>
							</b-row>
						</div>
					</div>
				</div>
			</b-col>
		</b-row>
	</div>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import DatePicker from "vue2-datepicker";

export default {
	mixins: [UtilityMixin],
	components: { DatePicker },
	data() {
		const now = new Date();
		const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
		const minDate = new Date(today);
		return {
			jsonDataSchedulazione: null,
			pianificazione: { giorni: null, orari: null, params: {} },
			days: [],
			daysSelected: [],
			hoursSelected: [],
			btnDisabledAggiungiOrario: true,
			orarioRiferimento: null,
			giorniSelezionati: null,
			min: minDate,
			numeroElencoProgrammato: 10,
			numeroElencoProgrammatoLbl: 0,
			elencoAttivitaProgrammate: [],
			daysWeekOptions: [],
			dayWeek: null,
			frequenzaDaysWeekOptions: [
				{ code: null, text: "-Frequenza-" },
				{ code: 1, text: "Primo" },
				{ code: 2, text: "Secondo" },
				{ code: 3, text: "Terzo" },
				{ code: 4, text: "Quarto" },
				{ code: 5, text: "Ultimo" },
			],
			frequenzaDayWeek: null,
		};
	},
	created() {
		//this.days = UtilityMixin.methods.getDaysOfWeekArray();

		this.daysWeekOptions = this.getDaysOfWeekArray();
		this.daysWeekOptions.unshift({ code: null, day: "-Seleziona Giorno-" });
	},
	mounted() {
		console.log(this);
		this.$emit("afterMounted");
	},
	computed: {
		dates() {
			return this.days.map((day) => day.date);
		},
		attributes() {
			return this.dates.map((date) => ({
				highlight: true,
				dates: date,
			}));
		},
	},
	watch: {
		jsonDataSchedulazione: {
			handler() {
				this.aggiornaOrari();
			},
			deep: true,
		},
		daysSelected() {
			console.log("Qui");
			let me = this;
			if (me.frequenzaDayWeek != null && me.dayWeek != null) {
				console.log(me.frequenzaDayWeek);
				console.log(me.dayWeek);
			}
			me.pianificazione.giorni = me.daysSelected ? me.daysSelected.join(",") : "";
			me.giorniSelezionati = me.pianificazione.giorni;
			this.$emit("updatePianificazioneGiorniMesi", me.pianificazione);
			if (me.daysSelected.length > 0) {
				me.orarioDisabled = false;
				me.btnDisabledAggiungiOrario = false;
			} else {
				me.hoursSelected = [];
				me.orarioDisabled = true;
				me.btnDisabledAggiungiOrario = true;
			}
		},
		hoursSelected() {
			let me = this;
			me.pianificazione.orari = me.hoursSelected ? me.hoursSelected.join(",") : "";
			this.$emit("updatePianificazioneGiorniMese", me.pianificazione);
		},
		giorniSelezionati() {
			this.$emit("updatePianificazioneGiorniMese", this.pianificazione);
			this.aggiornaOrari();
		},
		orarioRiferimento(value) {
			this.hoursSelected = [];
			this.hoursSelected.push(this.formatTime(value));
			this.aggiornaOrari();
		},
	},
	methods: {
		init(jsonData) {
			let me = this;
			me.jsonDataSchedulazione = jsonData;
		},
		getClass(index) {
			if (index % 2 === 0) {
				return "sa-utility-alternate-even";
			} else {
				return "sa-utility-alternate-odd";
			}
		},
		aggiornaOrari() {
			let me = this;
			me.elencoAttivitaProgrammate = [];
			if (me.pianificazione.giorni && this.orarioRiferimento) {
				let dataRiferimento = new Date();
				let giorni = me.pianificazione.giorni.split(",");
				let mese = dataRiferimento.getMonth();
				me.numeroElencoProgrammatoLbl = me.numeroElencoProgrammato * giorni.length;
				for (let x = 0; x < me.numeroElencoProgrammato; x++) {
					for (let giorno of giorni) {
						dataRiferimento.setDate(giorno);
						dataRiferimento.setMonth(mese);
						let oraRiferimento = new Date(this.orarioRiferimento);
						dataRiferimento.setHours(oraRiferimento.getHours());
						dataRiferimento.setMinutes(oraRiferimento.getMinutes());

						me.elencoAttivitaProgrammate.push(me.formatDateTimeCustom(dataRiferimento, "dddd DD MMMM YYYY HH:mm"));
					}
					mese++;
				}
			}
		},
		disbilitaOrePrecedenti(date) {
			let me = this;
			let today = new Date();
			let dataRiferimento = new Date(me.pianificazione.dataInizio);
			if (dataRiferimento.getFullYear() === today.getFullYear() && dataRiferimento.getMonth() === today.getMonth() && dataRiferimento.getDate() === today.getDate()) {
				return date.getHours() < new Date().getHours();
			} else {
				return false;
			}
		},
		setPianificazione(pianificazione) {
			let me = this;
			me.pianificazione = pianificazione;
			me.daysSelected = pianificazione.giorni ? pianificazione.giorni.split(",") : [];
			me.hoursSelected = pianificazione.orari ? pianificazione.orari.split(",") : [];
			me.numeroGiorni = me.pianificazione.giorni;
			if (me.pianificazione.orari) {
				me.orarioRiferimento = me.parseFormatDateTime(me.pianificazione.orari, "HH:mm").getTime();
			}
		},
		onInputDaysAll(value) {
			let me = this;
			me.daysSelected = [];
			if (value) {
				this.days.forEach((element) => {
					me.daysSelected.push(element.code);
				});
			}
		},
		onClickRemoveOrario(index) {
			let me = this;
			me.hoursSelected.splice(index, 1);
		},
		onClickAggiungiOrario() {
			let me = this;
			if (this.oraSelezionata) {
				me.hoursSelected.push(me.formatTime(this.oraSelezionata));
				me.hoursSelected = [...new Set(me.hoursSelected)];
				me.hoursSelected.sort();
			}
		},
		onContextCalendar(ctx) {
			//ctx.activeDate.getTime();
			console.log(ctx);
			let me = this;
			let giorno = me.formatDateTimeCustom(ctx.activeDate, "D");

			if (me.daysSelected.includes(giorno)) {
				me.daysSelected.splice(me.daysSelected.indexOf(giorno), 1);
			} else {
				me.daysSelected.push(giorno);
			}

			me.daysSelected = [...new Set(me.daysSelected)];
			me.daysSelected.sort((a, b) => {
				return a - b;
			});
			//console.log(me.formatDateTimeCustom(ctx.activeDate, "D"));
		},
		onDayClick(day) {
			console.log(day);
			console.log(day.id);
			console.log(day.date);
			let giorni = [];
			const idx = this.days.findIndex((d) => d.id === day.id);
			if (idx >= 0) {
				this.days.splice(idx, 1);
			} else {
				this.days.push({ id: day.id, date: day.date });
			}
			this.days.sort((a, b) => {
				return a.date.getTime() - b.date.getTime();
			});
			this.days.forEach((day) => {
				let giorno = this.formatDateTimeCustom(day.date, "D");
				giorni.push(giorno);
			});
			this.daysSelected = [...new Set(giorni)];
			//this.giorniSelezionati = giorni.join(",");
		},
		onInputFrequenzaDayWeek() {
			this.setGiornoMese();
		},
		onInputDayWeek() {
			this.setGiornoMese();
		},
		setGiornoMese() {
			let me = this;
			me.pianificazione.params.frequenzaDayWeek = me.frequenzaDayWeek;
			me.pianificazione.params.dayWeek = me.dayWeek;
			if (me.frequenzaDayWeek != null && me.dayWeek != null) {
				console.log("OK");
				this.$emit("updatePianificazioneGiorniMese", me.pianificazione);
			}
		},
	},
};
</script>

<style></style>
